import AsyncStorage from '@react-native-async-storage/async-storage';
import type { AuthData } from '../stores/useAuthStore';

export const storeCredentials = async (info: AuthData) => {
  try {
    const { refreshToken, authToken, currentUserId } = info;
    if (refreshToken) await AsyncStorage.setItem('refreshToken', refreshToken);
    if (authToken) await AsyncStorage.setItem('authToken', authToken);
    if (currentUserId)
      await AsyncStorage.setItem('currentUserId', currentUserId);
  } catch (e) {
    console.error(e);
  }
};

export const getStoredCredentials = async () => {
  const [storedAuthToken, storedRefreshToken, storedUserId] = await Promise.all(
    [
      AsyncStorage.getItem('authToken'),
      AsyncStorage.getItem('refreshToken'),
      AsyncStorage.getItem('currentUserId'),
    ],
  );

  return {
    authToken: storedAuthToken,
    refreshToken: storedRefreshToken,
    currentUserId: storedUserId,
  };
};

export const deleteStoredInfo = async () => {
  try {
    await AsyncStorage.removeItem('currentUserId');
    await AsyncStorage.removeItem('authToken');
    await AsyncStorage.removeItem('refreshToken');
    await AsyncStorage.removeItem('selected-community-id');
    await AsyncStorage.removeItem('selected-event-id');
    await AsyncStorage.removeItem('last-community-id');
    await AsyncStorage.removeItem('last-route');
  } catch (e) {
    console.error(e);
  }
};
